var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgCreditCardOutlined(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8333 2.0013H3.16667C2.43029 2.0013 1.83333 2.59826 1.83333 3.33464V8.66797C1.83333 9.40435 2.43029 10.0013 3.16667 10.0013H13.8333C14.5697 10.0013 15.1667 9.40435 15.1667 8.66797V3.33464C15.1667 2.59826 14.5697 2.0013 13.8333 2.0013ZM3.16667 0.667969C1.69391 0.667969 0.5 1.86188 0.5 3.33464V8.66797C0.5 10.1407 1.69391 11.3346 3.16667 11.3346H13.8333C15.3061 11.3346 16.5 10.1407 16.5 8.66797V3.33464C16.5 1.86188 15.3061 0.667969 13.8333 0.667969H3.16667Z",
    fill: "var(--primary-4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6111 5.77908L1.38889 5.77908L1.38889 4.44575L15.6111 4.44574V5.77908Z",
    fill: "var(--primary-4)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardOutlined);
export default __webpack_public_path__ + "static/media/creditCardOutlined.587a28235d5e03be24601c7055c6591e.svg";
export { ForwardRef as ReactComponent };